import React from 'react';
import { useTranslation } from 'react-i18next';
import { IoIosArrowForward } from 'react-icons/io';

import { HOME_STATUS } from 'components/evieApp/utils';
import { useEvieHomeContext } from '../EvieHomeProvider';

import './program-info-card.scss';

const ProgramInfoCard = () => {
  const { t } = useTranslation();
  const { changeHomeStatus } = useEvieHomeContext();

  return (
    <button type="button" className="program-info-card" onClick={() => changeHomeStatus(HOME_STATUS.PROGRAM)}>
      <div className="program-info-card__img" />
      <section className="program-info-card__content">
        <div className="program-info-card__content_labels">
          <h2>{t('evieApp.programInfoCard.title')}</h2>
          <p>{t('evieApp.programInfoCard.content')}</p>
        </div>
      </section>
      <IoIosArrowForward className="program-info-card__icon" />
    </button>
  );
};

export default ProgramInfoCard;
